import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {NestApiProvider} from '../nest-api';

@Injectable()
export class Pnd91Api {
  private readonly service: string = 'payroll';
  private readonly model: string = 'pnd91';

  constructor(
      private nestApiProvider: NestApiProvider,
  ) {
  }

  public genPnd91(filter: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'genPnd91';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) urlParams.filter = filter;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public getZipFile(filter: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getZipFile';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) urlParams.filter = filter;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/pnd91.api.ts